import styled from "styled-components";

export const HomepageHeaderArenaMenuItemIconDefaultBox = styled.div`
  position: absolute;
  left: 0;
  top: 1px;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    top: 3px;
  }
`;
